<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="selectData" :reset="reset"></queryCondition>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="openAdd">新建</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="phoneType" label="手机厂商" align="center" width="100">
                    <template slot-scope="scope">
                        {{ phoneTypeLabel(scope.row.phoneType) }}
                    </template>
                </el-table-column>
                <el-table-column prop="xianShangVer" label="线上版本" align="center" width="120"></el-table-column>
                <el-table-column prop="shenHeVer" label="审核版本" align="center" width="120"></el-table-column>
                <el-table-column prop="shenHe" label="审核状态" align="center" width="110">
                    <template slot-scope="scope">
                        <el-tag :type="Number(scope.row.shenHe) === 1 ? 'success' : 'info'" size="small">
                            {{ Number(scope.row.shenHe) === 1 ? '开启审核' : '关闭审核' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="appLink" label="下载链接" align="center" min-width="180" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <a v-if="scope.row.appLink" :href="scope.row.appLink" target="_blank" rel="noopener noreferrer" class="link">{{ scope.row.appLink }}</a>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="creationTime" label="创建时间" align="center" width="170"></el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="100">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" size="mini" @click="updateTip(scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDialog" title="新增App版本" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">手机厂商</div>
                    <div class="value">
                        <el-select v-model="addData.phoneType" size="small" placeholder="请选择" style="width:100%">
                            <el-option v-for="item in phoneTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">线上版本</div>
                    <div class="value">
                        <el-input v-model="addData.xianShangVer" size="small" placeholder="请输入线上版本"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">审核版本</div>
                    <div class="value">
                        <el-input v-model="addData.shenHeVer" size="small" placeholder="请输入审核版本"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">审核状态</div>
                    <div class="value">
                        <el-radio-group v-model="addData.shenHe">
                            <el-radio :label="0">关闭审核</el-radio>
                            <el-radio :label="1">开启审核</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="item">
                    <div class="label">下载链接</div>
                    <div class="value">
                        <el-input v-model="addData.appLink" size="small" placeholder="请输入下载链接"></el-input>
                        <div class="upload-line">
                            <el-upload
                                action=""
                                :show-file-list="false"
                                :http-request="uploadApkForAdd">
                                <el-button type="primary" icon="el-icon-upload" size="small">上传APK</el-button>
                            </el-upload>
                        </div>
                    </div>
                </div>
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="addFun()">确认</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isUpdateDialog" title="编辑App版本" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">手机厂商</div>
                    <div class="value">
                        <el-select v-model="editData.phoneType" size="small" placeholder="请选择" style="width:100%">
                            <el-option v-for="item in phoneTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">线上版本</div>
                    <div class="value">
                        <el-input v-model="editData.xianShangVer" size="small" placeholder="请输入线上版本"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">审核版本</div>
                    <div class="value">
                        <el-input v-model="editData.shenHeVer" size="small" placeholder="请输入审核版本"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">审核状态</div>
                    <div class="value">
                        <el-radio-group v-model="editData.shenHe">
                            <el-radio :label="0">关闭审核</el-radio>
                            <el-radio :label="1">开启审核</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="item">
                    <div class="label">下载链接</div>
                    <div class="value">
                        <el-input v-model="editData.appLink" size="small" placeholder="请输入下载链接"></el-input>
                        <div class="upload-line">
                            <el-upload
                                action=""
                                :show-file-list="false"
                                :http-request="uploadApkForEdit">
                                <el-button type="primary" icon="el-icon-upload" size="small">上传APK</el-button>
                            </el-upload>
                        </div>
                    </div>
                </div>
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="editFun()">确认</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'

const emptyForm = () => ({
    phoneType: '0',
    xianShangVer: '',
    shenHeVer: '',
    shenHe: 0,
    appLink: '',
})

export default {
    name: 'versionControl',
    components: {
        queryCondition,
    },
    data() {
        return {
            isAddDialog: false,
            isUpdateDialog: false,
            addData: emptyForm(),
            editData: {},
            allData: [],
            tableData: [],
            phoneTypeList: [
                { value: '0', label: '通用' },
                { value: '1', label: '华为' },
                { value: '2', label: '小米' },
                { value: '3', label: 'Oppo' },
                { value: '4', label: 'Vivo' },
                { value: '5', label: '三星' },
                { value: '10', label: '苹果' },
                { value: '11', label: '荣耀' },
                { value: '20', label: 'h5' },
            ],
            conditionData: {
                phoneType: '',
                xianShangVer: '',
            },
            queryList: [
                {
                    type: 'select',
                    label: '手机厂商:',
                    name: 'phoneType',
                    options: [
                        { value: '', label: '全部' },
                        { value: '0', label: '通用' },
                        { value: '1', label: '华为' },
                        { value: '2', label: '小米' },
                        { value: '3', label: 'Oppo' },
                        { value: '4', label: 'Vivo' },
                        { value: '5', label: '三星' },
                        { value: '10', label: '苹果' },
                        { value: '11', label: '荣耀' },
                        { value: '20', label: 'h5' },
                    ],
                },
                { type: 'input', label: '线上版本:', name: 'xianShangVer' },
            ],
        }
    },
    mounted() {
        setTimeout(() => {
            this.loadingData()
        }, 300)
    },
    methods: {
        phoneTypeLabel(val) {
            const item = this.phoneTypeList.find(i => String(i.value) === String(val))
            return item ? item.label : (val === undefined || val === null || val === '' ? '-' : val)
        },
        getUploadUrl(res) {
            const data = res && res.data ? res.data.data : ''
            if (typeof data === 'string') {
                return data
            }
            if (data && typeof data === 'object') {
                return data.url || data.fileUrl || data.downloadUrl || data.path || ''
            }
            return ''
        },
        openAdd() {
            this.addData = emptyForm()
            this.isAddDialog = true
        },
        async uploadApkForAdd(file) {
            const res = await api.uploadApk(file.file)
            const url = this.getUploadUrl(res)
            if (url) {
                this.addData.appLink = url
                this.$message({ type: 'success', message: '上传成功' })
            }
        },
        async uploadApkForEdit(file) {
            const res = await api.uploadApk(file.file)
            const url = this.getUploadUrl(res)
            if (url) {
                this.editData.appLink = url
                this.$message({ type: 'success', message: '上传成功' })
            }
        },
        async addFun() {
            if (!this.addData.xianShangVer) {
                this.$message({ type: 'warning', message: '请输入线上版本' })
                return
            }
            const res = await api.appVerAdd(this.addData)
            if (res.data.code == '200' || res.data.code == 200) {
                this.$message({ type: 'success', message: '新增成功' })
                this.isAddDialog = false
                this.addData = emptyForm()
                this.loadingData()
            }
        },
        async editFun() {
            if (!this.editData.xianShangVer) {
                this.$message({ type: 'warning', message: '请输入线上版本' })
                return
            }
            const payload = {
                id: this.editData.id,
                creationTime: this.editData.creationTime,
                phoneType: this.editData.phoneType,
                xianShangVer: this.editData.xianShangVer,
                shenHeVer: this.editData.shenHeVer,
                shenHe: this.editData.shenHe,
                appLink: this.editData.appLink,
            }
            const res = await api.appVerUpdate(payload)
            if (res.data.code == '200' || res.data.code == 200) {
                this.$message({ type: 'success', message: '编辑成功' })
                this.isUpdateDialog = false
                this.loadingData()
            }
        },
        updateTip(row) {
            this.editData = {
                id: row.id,
                creationTime: row.creationTime,
                phoneType: row.phoneType === undefined || row.phoneType === null ? '' : String(row.phoneType),
                xianShangVer: row.xianShangVer || '',
                shenHeVer: row.shenHeVer || '',
                shenHe: Number(row.shenHe) === 1 ? 1 : 0,
                appLink: row.appLink || '',
            }
            this.isUpdateDialog = true
        },
        tableHeaderColor({ rowIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        filterTable() {
            let list = this.allData || []
            if (this.conditionData.phoneType !== '' && this.conditionData.phoneType !== null && this.conditionData.phoneType !== undefined) {
                list = list.filter(item => String(item.phoneType) === String(this.conditionData.phoneType))
            }
            if (this.conditionData.xianShangVer) {
                const key = String(this.conditionData.xianShangVer).trim()
                list = list.filter(item => String(item.xianShangVer || '').indexOf(key) > -1)
            }
            this.tableData = list
        },
        async loadingData() {
            const res = await api.appVerList()
            if (res.data.code == '200' || res.data.code == 200) {
                const data = res.data.data
                this.allData = Array.isArray(data) ? data : (data && data.records ? data.records : [])
                this.filterTable()
            }
        },
        selectData() {
            this.filterTable()
        },
        reset() {
            this.conditionData = {
                phoneType: '',
                xianShangVer: '',
            }
            this.filterTable()
        },
    },
}
</script>

<style lang="scss" scoped>
.condition {
    background-color: #ffffff;
    display: flex;
    align-items: center;
    border-radius: 5px;
    padding: 15px;
    font-size: 14px;
}
.table {
    margin-top: 10px;
    background-color: #ffffff;
    padding: 15px;
    .handle {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding-bottom: 15px;
        align-items: center;
        font-size: 20px;
    }
}
.dialog {
    .item {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        .label {
            width: 100px;
            flex-shrink: 0;
            text-align: right;
            padding-right: 12px;
            color: #606266;
        }
        .value {
            flex: 1;
        }
    }
    .btns {
        text-align: center;
    }
}
.upload-line {
    margin-top: 10px;
}
.link {
    color: #409eff;
    text-decoration: none;
}
</style>
